import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { concatAll, reduce, switchMap, } from 'rxjs/operators';

import { doValidate } from '../store/order-checkout/order-checkout.effects';
import * as fromApp from '../../store/app.reducers';
import { getCartId } from '../../store/app.reducers';
import { ClearLimbusErrorResponse } from '../../store/cart/cart.actions';

export const enum NavDirection {
    Previous,
    Forward,
    Default
}

@Injectable()
export class CheckoutValidationService {

    navigationDirection: NavDirection;

    constructor(
        private httpClient: HttpClient,
        private store: Store<fromApp.AppState>) { }

    validate(data) {
        return this.store.select(getCartId)
            .pipe(
                switchMap(cartId => doValidate(data, cartId, this.httpClient))
            );
    }

    setDirection(dir: NavDirection) {
        this.navigationDirection = dir;
    }

}


